<template>
  <div class="About">
    <div class="About_wrap">
      <div class="About_banner">
        <p>{{$t("about.abouttitle")}}</p>
      </div>
    </div>
    <div class="About_wrapa" ref="AboutPage">
      <div class="About_us">
        <div class="About_us_tites">
          <headerbar v-bind:message="$t(aboutMeg)"></headerbar>
        </div>
        <div class="About_us_content">
          <div class="About_us_content_img">
            <img v-lazy="aboutimg" alt="">
          </div>
          <div class="About_us_content_text">
            <p>{{$t("about.companytext")}}</p>
            <!-- 在各种硬件平台上实现准确的ADAS功能我们的愿景是做中国自主最强的具有世界影响力的自动驾驶供应商。 -->
            <h5 style="font-size:16px;">{{$t("about.companybottom")}}</h5>
            <!-- L0-L3自动驾驶的系统 -->
          </div>
        </div>
      </div>
    </div>
    <div class="About_wrapb" ref="AboutPage1">
      <div class="About_join">
        <div class="About_join_tites">
          <headerbar v-bind:message="$t(joinMeg)"></headerbar>
        </div>
        <div class="About_join_content">
          <div class="About_join_content_text">
            {{$t("about.Joinustext")}}
          </div>
          <div class="About_join_content_icon"></div>
          <a class="About_join_content_button" :class="pulse" @mouseenter="enterOrLeave(1)" @mouseleave="enterOrLeave(2)" href="#" @click="aboutbutton()"> {{$t("about.Joinuslook")}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerbar from "../components/common/header.vue"
export default {
  name: 'About',
  data() {
    return {
      clientHeight: "",
      aboutMeg: "about.company",
      joinMeg: "about.Joinus",
      pulse: 'animated',
      aboutimg: require("../assets/images/Aboutsa.png")
    }
  },
  components: { headerbar },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight)
    }
  },
  methods: {
    changeFixed(clientHeight) {                        //动态修改样式
      console.log(clientHeight);
      
      if (document.documentElement.clientWidth >= 1565) {
        this.$refs.AboutPage.style.height = clientHeight - 80 + 'px';
        this.$refs.AboutPage1.style.height = clientHeight - 280 + 'px';
      }


    },
    enterOrLeave(val) {
      if (val === 1) {
        $('.About_join_content_button').addClass('pulse')
      } else {
        $('.About_join_content_button').removeClass('pulse')
      }
    },
    aboutbutton() {
      window.open("https://www.zhipin.com/gongsi/be1673b98797ed6e1Hd-2t-1.html?ka=company-intro");
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@media screen and (min-width:1629px) {
  /*当屏幕尺寸小于1921px时，应用下面的CSS样式*/
  .About_join {
    width: 78%;
    margin: 0 auto;
    padding-bottom: 30px;
  }
  .About_wrapb {
    width: 100%;
    background: rgba(251, 251, 251, 1);
  }
  .About_join_content_text {
    margin: 0 auto;
    margin-top: 20px;
    width: 647px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(37, 38, 49, 1);
    line-height: 30px;
  }
  .About_us_content {
    display: flex;
    width: 849px;
    margin: 0 auto;
    margin-top: 102px;
  }
}

@media screen and (min-width:1300px) and (max-width:1630px) {
  .About_join {
    width: 78%;
    margin: 0 auto;
    padding-bottom: 30px;
  }
  .About_wrapb {
    width: 100%;
    background: #fff;
  }
  .About_join_content_text {
    margin: 0 auto;
    margin-top: 90px;
    width: 647px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(37, 38, 49, 1);
    line-height: 30px;
  }
  .About_us_content {
    display: flex;
    width: 849px;
    margin: 0 auto;
    margin-top: 102px;
  }
}
@media screen and (max-width:1299px) {
   .About_join {
    width: 78%;
    margin: 0 auto;
    padding-bottom: 30px;
  }
  .About_wrapb {
    width: 100%;
    background: #fff;
  }
  .About_us_content {
    display: flex;
    width: 849px;
    margin: 0 auto;
    margin-top: 40px;
    /*background: pink;*/
  }
  .About_join_content_text {
    margin: 0 auto;
    margin-top: 30px;
    width: 647px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(37, 38, 49, 1);
    line-height: 30px;
  }
  
}

.About_wrap {
  width: 100%;
  height: 360px;
  background: url("../assets/images/VCG21gic150679Copy.png");
  background-size: 100% 100%;
}

.About_banner {
  width: 970px;
  margin: 0 auto;
}

.About_banner p {
  text-align: center;
  height: 360px;
  line-height: 360px;
  font-size: 56px;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  letter-spacing: 1px;
}

.About_wrapa {
  width: 100%;
  /*height:1000px;*/
  background: #fff;
}

.About_us {
  width: 78%;
  margin: 0 auto;
}



.About_us_content_img {
  width: 284px;
  height: 280px;
}

.About_us_content_img img {
  width: 100%;
  height: 100%;
}

.About_us_content_text {
  width: 475px;
  height: 271px;
  margin-left: 80px;
}

.About_us_content_text p {
  width: 478px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(37, 38, 49, 1);
  line-height: 30px;
}

.About_us_content_text h5 {
  font-size: 18px;
  font-weight: 600;
  color: rgba(37, 38, 49, 1);
  line-height: 30px;
  margin-top: 15px;
}


/*.About_join_content{

}*/

.About_join_content_icon {
  margin: 0 auto;
  margin-top: 25px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 14px solid #A0A0A0;
}

.About_join_content_button {
  display: block;
  width: 260px;
  height: 48px;
  border: 1px solid #ccc;
  font-size: 14px;
  line-height: 47px;
  text-align: center;
  margin: 0 auto;
  margin-top: 35px;
}

.Journalism_news_content {
  width: 620px;
  margin: 0 auto;
  background: pink;
}

.Journalism_news_content ul {
  /*display: flex;*/
}

.Journalism_news_content ul li {
  /*display: inline-block;
  width:200px;
  height:200px;*/
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue